export default "__VITE_ASSET__57a2ffdb__"